import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  rootTabs: {
    color: '#828282',
    '& .MuiTab-root': {
      textTransform: 'uppercase',
      fontSize: '12px',
      fontWeight: 600
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .Mui-selected': {
      color: '#4277C6'
    },
    '& .MuiTab-textColorInherit': {
      opacity: 1
    }
  },
  tabsTitles: {
    textTransform: 'capitalize',
  },
  root: {
    '& > .MuiToolbar-root': {
      borderTop: '1px solid #D0E9FF'
    },
    '& .MuiTableCell-head, & .MuiTableCell-head .MuiButton-root': {
      color: '#4277C6',
      textTransform: 'uppercase',
      fontSize: '12px',
      fontWeight: 600
    },
    '& .MuiTableCell-head': {
      borderColor: '#D0E9FF',
    },
    '& .MuiButton-label *': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777',
      fontWeight: 500
    },
    '& .MuiCheckbox-root': {
      color: '#4B6FC2'
    },
    '& .MuiTableFooter-root': {
      background: '#E7F0FF',
      color: '#4B6FC2',
      '& .MuiSelect-icon, & .MuiTablePagination-root': {
        color: '#4B6FC2'
      },
      '& .MuiIconButton-root.Mui-disabled': {
        color: '#4B6FC2',
        opacity: '0.44'
      }
    }
  },
  requestSkuButton: {
    textTransform: 'uppercase',
    '@media (max-width: 768px)': {
      marginTop: '10px',
    }
  }
}));

export default useStyles;
